export default {
  text: '#2d2d2d',
  primary: '#203368',
  secondary: '#c0272a',
  background: 'white',
  backgroundSecondary: '#e9dac6',
  light: '#FFF',
  dark: '#020303'
}
